{
  "names": {
    "Fajr": "Fajr",
    "Dhuhr": "Dhuhr",
    "Asr": "Asr",
    "Maghrib": "Maghrib",
    "Isha": "Isha"
  },
  "card": {
    "label": "Próxima oración",
    "labelTomorrow": "Mañana · {{prayer}}",
    "inHoursMinutes": "en {{hours}} h {{minutes}} min",
    "inMinutes": "en {{minutes}} min",
    "open_aria": "Abrir horarios de oración",
    "pro": "Rhemn Pro",
    "unlock_aria": "Desbloquea los horarios de oración con Rhemn Pro",
    "unavailable": "Los horarios de oración no están disponibles ahora mismo."
  },
  "sheet": {
    "bellOn_aria": "Desactivar el recordatorio de {{prayer}}",
    "bellOff_aria": "Activar el recordatorio de {{prayer}}",
    "explainer": "Recibe un recordatorio suave en cada oración. Los recordatorios son notificaciones silenciosas, sin sonido por defecto.",
    "enableReminders": "Activar recordatorios",
    "enableInSettings": "Activa las notificaciones de Rhemn en Ajustes para recibir recordatorios de oración.",
    "openSettings": "Abrir Ajustes"
  },
  "notifications": {
    "body": "Es hora de orar."
  },
  "focus": {
    "label": "Oración del {{prayer}}",
    "close_aria": "Cerrar pantalla de oración",
    "hint": "Pulsa Esc o × para volver",
    "phrases": {
      "accepted": "Que Allah acepte tu oración",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "Comienza con intención. Continúa con barakah.",
    "prayerApproaches": "Tu próxima oración se acerca. Mantente anclado en tu intención.",
    "morningPursue": "Una mañana bendecida para perseguir: {{focus}}",
    "dayCloses": "Mientras el día llega a su fin, reflexiona sobre: {{focus}}",
    "fulfilled": "Cumpliste tu intención hoy. Alhamdulillah.",
    "workingTowards": "Hoy estás trabajando hacia: {{focus}}",
    "prayerNear": "Tu próxima oración está cerca. Respira hondo."
  },
  "widget": {
    "countdown": "en {{time}}",
    "openToUpdate": "Abre Rhemn para actualizar",
    "openForVerse": "Abre Rhemn para ver la aleya de hoy"
  }
}
